import React, { useState } from 'react';
import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

const CreateRoster = () => {
  const [formData, setFormData] = useState({
    eventId: '',
    rosterName: '',
    description: ''
  });
  const [selectedPlayers, setSelectedPlayers] = useState([]);
  const navigate = useNavigate();

  const availablePlayers = [
    { id: 1, name: 'John Doe', position: 'Pitcher' },
    { id: 2, name: 'Jane Smith', position: 'Catcher' },
    { id: 3, name: 'Mike Johnson', position: 'Infielder' },
    { id: 4, name: 'Sarah Wilson', position: 'Outfielder' }
  ];

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handlePlayerToggle = (playerId) => {
    setSelectedPlayers(prev => 
      prev.includes(playerId) 
        ? prev.filter(id => id !== playerId)
        : [...prev, playerId]
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (selectedPlayers.length === 0) {
      toast.error('Please select at least one player');
      return;
    }
    toast.success('Roster created successfully!');
    navigate('/rosters');
  };

  return (
    <div className="max-w-4xl mx-auto bg-white rounded-lg shadow p-6">
      <h1 className="text-2xl font-bold mb-6">Create New Roster</h1>
      
      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Event</label>
            <select
              name="eventId"
              value={formData.eventId}
              onChange={handleChange}
              required
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="">Select Event</option>
              <option value="1">National Championship 2024</option>
              <option value="2">Regional Tournament</option>
              <option value="3">State League</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Roster Name</label>
            <input
              type="text"
              name="rosterName"
              value={formData.rosterName}
              onChange={handleChange}
              required
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">Description</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            rows={3}
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          />
        </div>

        <div>
          <h3 className="text-lg font-medium text-gray-900 mb-4">Select Players</h3>
          <div className="border border-gray-300 rounded-md p-4 max-h-64 overflow-y-auto">
            {availablePlayers.map((player) => (
              <div key={player.id} className="flex items-center space-x-3 py-2">
                <input
                  type="checkbox"
                  id={`player-${player.id}`}
                  checked={selectedPlayers.includes(player.id)}
                  onChange={() => handlePlayerToggle(player.id)}
                  className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                />
                <label htmlFor={`player-${player.id}`} className="flex-1 cursor-pointer">
                  <span className="text-sm font-medium text-gray-900">{player.name}</span>
                  <span className="text-sm text-gray-500 ml-2">({player.position})</span>
                </label>
              </div>
            ))}
          </div>
          <p className="text-sm text-gray-500 mt-2">
            Selected: {selectedPlayers.length} players
          </p>
        </div>

        <div className="flex gap-4">
          <button
            type="button"
            onClick={() => navigate('/rosters')}
            className="flex-1 py-2 px-4 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="flex-1 py-2 px-4 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            Create Roster
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateRoster;